import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Warning from "../../images/warning.svg";
import Question from "../../images/icons/question.svg";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import { Button, Collapse, Dialog, DialogContent, DialogContentText, DialogTitle, List, ListItem, ListItemIcon, ListItemText, Modal, DialogActions } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import { TrendingUpRounded } from "@material-ui/icons";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 370,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 20,
    fontFamily: "Roboto",
    color: "#7EBDCE",
    // textAlign: "center",
    // margin: "40px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const FunctionalitiesComponent = ({ functionalities = [], localSelectedRole = [], moduleId, changeFunctionalityCheckModalEvent }) => {
  const classes = useStyles();

  const isCheckedFunctionality = (fucnId) => {
    const moduleRecord = localSelectedRole?.find(record => record?.code === moduleId);
    const s = moduleRecord?.functionalityList?.find(record => record?.id === fucnId);
    return s !== undefined;
  }

  const onChangeCheck = (fucnId, value) => {
    
    changeFunctionalityCheckModalEvent(fucnId, !value, moduleId);
  }

  return (
    <Collapse in={true} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {functionalities?.map((x) => (
          <ListItem key={x?.id} button className={classes.nested}>
            <ListItemIcon>
              <Checkbox
                color="primary"
                edge="start"
                checked={isCheckedFunctionality(x?.id)}
                onChange={()=>{ onChangeCheck(x?.id, isCheckedFunctionality(x?.id)) }}
                // checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                
                inputProps={{ 'aria-labelledby': `checkbox-list-label-${x?.id}` }}
              />
            </ListItemIcon>
            <ListItemText primary={x?.description} />

          </ListItem>))}
      </List>
    </Collapse>
  )
};

const BodyDialog = ({allChecked, modules = [], openModalEvent, selectedRole, localSelectedRole,   changeModuleCheckModalEvent,
  changeFunctionalityCheckModalEvent }) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);

  const isCheckedModule = (moduleId) => {
    const s = localSelectedRole?.find(record => record?.code === moduleId);
    return s !== undefined;
  }
  const isAllCheckedModule = (moduleId) => {
    const s = modules?.find(record => record?.code === moduleId);
    return s !== undefined;
  }

  const onChangeCheck = (code, value) => {
    changeModuleCheckModalEvent(code, value);
  }

  return (
    <>
      {modules?.map((x) => (
        <>
          <ListItem key={x?.code} role={undefined} dense button >
            <ListItemIcon>
              <Checkbox
                color="primary"
                edge="start"
                onChange={() => { onChangeCheck(x?.code, !isCheckedModule(x?.code)) }}
                checked={ isCheckedModule(x?.code)}
                indeterminate={isCheckedModule(x?.code)}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': `checkbox-list-label-${x?.code}` }}
              />
            </ListItemIcon>
            <ListItemText primary={x.description} />

          </ListItem>
          <FunctionalitiesComponent moduleId={x?.code} functionalities={x?.functionalityList} localSelectedRole={localSelectedRole} selectedRole={selectedRole}  
              changeFunctionalityCheckModalEvent={changeFunctionalityCheckModalEvent} />
        </>

      ))}

    </>
  )
};

const ModalModule = ({
  modules,
  handleClick,
  handleClickOut,
  type,
  title,
  selectedAllRoles,
  oneButtons,
  textButtonSubmit,
  openModalEvent,
  closeModalEvent,
  openModal,
  selectedRole,
  localSelectedRole,
  changeModuleCheckModalEvent,
  changeFunctionalityCheckModalEvent,
  acceptModalEvent,
  cancelModalEvent
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [allChecked, setAllChecked] = React.useState(true);



  return (
    <div>
      <Dialog
        open={openModal}
        onClose={openModalEvent}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          <Checkbox
            color="primary"
            indeterminate
            onChange={() => {setAllChecked(!allChecked); selectedAllRoles(allChecked)}}
            checked={allChecked }
            inputProps={{ 'aria-label': 'indeterminate checkbox' }}
          />
        ASIGNAR MÓDULOS</DialogTitle>
        <DialogContent dividers='paper'>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            <BodyDialog 
              allChecked={allChecked}
              modules={modules}
              openModalEvent={openModalEvent}
              selectedRole={selectedRole}
              localSelectedRole={localSelectedRole}
              changeModuleCheckModalEvent={changeModuleCheckModalEvent}
              changeFunctionalityCheckModalEvent={changeFunctionalityCheckModalEvent} />

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className={classes.accept}
              type="button"
              variant="contained"
              onClick={() => {
                cancelModalEvent()
              }}
            >
              Cancelar
  </Button>

            <Button
              className={classes.cancel}
              type={oneButtons ? 'button' : "submit"}
              variant="contained"
              color="secondary"
              onClick={()=>{acceptModalEvent()}}
            >
              {textButtonSubmit ? textButtonSubmit : 'Aceptar'}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ModalModule;
